let configs = {
  altInput: true,
  altFormat: "j F Y",
  dateFormat: "Y-m-d"
}

export {configs}